import { render, staticRenderFns } from "./OutsideAdvertise.vue?vue&type=template&id=ca290a78&scoped=true&"
import script from "./OutsideAdvertise.vue?vue&type=script&lang=js&"
export * from "./OutsideAdvertise.vue?vue&type=script&lang=js&"
import style0 from "./OutsideAdvertise.vue?vue&type=style&index=0&id=ca290a78&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca290a78",
  null
  
)

export default component.exports